// Inventory API helpers — Phase 1D-δ-1
// Wraps /api/inventory/* endpoints for the 4 δ-1 modules:
//   materials, material-issues, finished-goods (balance/mov/transfer/prod-in)
import { api } from "./api";

// ---------- Master Bahan ----------
export const listMaterials = (params) => api.get("/inventory/materials", { params });
export const createMaterial = (body) => api.post("/inventory/materials", body);
export const updateMaterial = (id, body) => api.patch(`/inventory/materials/${id}`, body);
export const getMaterial = (id) => api.get(`/inventory/materials/${id}`);

// ---------- Material Issue ----------
export const listMaterialIssues = (params) =>
  api.get("/inventory/material-issues/", { params });
export const getMaterialIssue = (id) =>
  api.get(`/inventory/material-issues/${id}`);
export const createMaterialIssue = (body) =>
  api.post("/inventory/material-issues/", body);
// Batch 2.3: reject/remake terbuka milik WO — untuk menawarkan tautan
// saat tujuan pengeluaran = REJECT_REMAKE.
export const listOpenRejectRemakes = (woId) =>
  api.get(`/inventory/material-issues/open-reject-remakes/${woId}`);
export const patchMaterialIssueItems = (id, body) =>
  api.patch(`/inventory/material-issues/${id}/items`, body);
export const submitMaterialIssue = (id) =>
  api.post(`/inventory/material-issues/${id}/submit`);
export const approveMaterialIssue = (id) =>
  api.post(`/inventory/material-issues/${id}/approve`);
export const cancelMaterialIssue = (id, body) =>
  api.post(`/inventory/material-issues/${id}/cancel`, body);

// ---------- Finished Goods ----------
export const listFGBalance = (params) =>
  api.get("/inventory/finished-goods/", { params });
export const getFGBalance = (id) =>
  api.get(`/inventory/finished-goods/${id}`);

export const listFGTransfers = (params) =>
  api.get("/inventory/finished-goods/transfers", { params });
export const getFGTransfer = (id) =>
  api.get(`/inventory/finished-goods/transfers/${id}`);
export const createFGTransfer = (body) =>
  api.post("/inventory/finished-goods/transfers", body);
export const dispatchFGTransfer = (id) =>
  api.post(`/inventory/finished-goods/transfers/${id}/dispatch`);
export const receiveFGTransfer = (id) =>
  api.post(`/inventory/finished-goods/transfers/${id}/receive`);
export const cancelFGTransfer = (id, body) =>
  api.post(`/inventory/finished-goods/transfers/${id}/cancel`, body);

export const productionIn = (body) =>
  api.post("/inventory/finished-goods/production-in", body);

// ---------- Stock Ledger (δ-2) ----------
export const listStockLedger = (params) =>
  api.get("/inventory/stock/ledger", { params });
export const getStockLedger = (id) =>
  api.get(`/inventory/stock/ledger/${id}`);
export const listStockBalance = (params) =>
  api.get("/inventory/stock/balance", { params });

// ---------- Stock Adjustment (δ-2) ----------
export const listAdjustments = (params) =>
  api.get("/inventory/adjustments", { params });
export const getAdjustment = (id) =>
  api.get(`/inventory/adjustments/${id}`);
export const createAdjustment = (body) =>
  api.post("/inventory/adjustments", body);
export const approveAdjustment = (id, body) =>
  api.post(`/inventory/adjustments/${id}/approve`, body);
export const rejectAdjustment = (id, body) =>
  api.post(`/inventory/adjustments/${id}/reject`, body);
export const cancelAdjustment = (id, body) =>
  api.post(`/inventory/adjustments/${id}/cancel`, body);

// ---------- Stock Opname (δ-2) ----------
export const listOpname = (params) => api.get("/inventory/opname", { params });
export const getOpname = (id) => api.get(`/inventory/opname/${id}`);
// Lembar hitung LENGKAP satu opname (28 Sep 2026): seluruh bahan + jumlah sistem + hasil hitung, dari server.
export const getOpnameLembar = (id) => api.get(`/inventory/opname/${id}/lembar-hitung`);
export const createOpname = (body) => api.post("/inventory/opname", body);
export const startOpname = (id) => api.post(`/inventory/opname/${id}/start`);
export const upsertOpnameItems = (id, body) =>
  api.post(`/inventory/opname/${id}/items`, body);
export const finalizeOpname = (id) =>
  api.post(`/inventory/opname/${id}/finalize`);
export const cancelOpname = (id, body) =>
  api.post(`/inventory/opname/${id}/cancel`, body);

// ---------- FG Movement (δ-2) ----------
export const listFGMovements = (params) =>
  api.get("/inventory/finished-goods/movements", { params });
export const getFGMovement = (id) =>
  api.get(`/inventory/finished-goods/movements/${id}`);

// ---------- Backend error → kalimat yang dibaca staf ----------
// `detail.message` dari backend tampil apa adanya (kalimatnya ditulis di backend, ikut pagar bahasa K200).
// `petaKode` (opsional): kalimat per `detail.error` untuk galat yang backend kirim TANPA `message`
// (mis. `{error:"REGION_SCOPE"}`). K200 butir 1 & 6: kode mentah (`FA_NOT_FOUND`) dan kalimat Inggris axios
// ("Request failed with status code 500", "Network Error") TIDAK PERNAH tampil ke staf — kode yang tidak dikenal
// diganti kalimat menurut jenis galatnya. Objek tetap tidak boleh sampai ke toast/JSX
// ("Objects are not valid as a React child" — WO-DETAIL-403-LAYAR-CRASH-01).
// K202 (VONIS-27SEP-TANYA-RAMAH butir 2): tiap penolakan = alasan singkat + apa yang bisa dilakukan / siapa yang
// bisa membantu. Sejalan dengan `backend/services/pesan_ramah.py` (backend kini melengkapi `message` untuk kode ini
// sendiri; peta ini tetap jadi jaring bila kalimat backend tidak ada). Dijaga `backend/tests/test_pagar_pesan_ramah.py`.
const WILAYAH_LAIN =
  "Data ini milik cabang lain, jadi tidak bisa dibuka dari cabang Anda. Kalau Anda memang perlu, minta Kepala Cabang pemilik data atau Owner.";
const PERAN_TIDAK_BERHAK =
  "Peran Anda tidak punya hak untuk tindakan ini. Kalau memang perlu, minta bantuan Kepala Cabang Anda atau Owner.";
const HANYA_OWNER = "Tindakan ini hanya bisa dilakukan Owner. Kalau perlu, hubungi Owner.";
const hilang = (apa) => `${apa} tidak ditemukan. Mungkin sudah dihapus atau nomornya salah. Muat ulang halaman, lalu cari lagi.`;
const BELUM_DIUBAH = "Belum ada yang diubah. Ubah isiannya dulu, lalu simpan lagi.";
const SUDAH_DIPUTUS = "Pengajuan ini sudah diputus sebelumnya. Muat ulang halaman untuk melihat hasilnya.";

export const PESAN_KODE_UMUM = {
  // wilayah / toko / peran
  REGION_SCOPE: WILAYAH_LAIN,
  REGION_SCOPE_FORBIDDEN: WILAYAH_LAIN,
  OUT_OF_SCOPE: WILAYAH_LAIN,
  FORBIDDEN_SCOPE: WILAYAH_LAIN,
  STORE_SCOPE: "Data ini milik toko lain, jadi tidak bisa dibuka dari akun Anda. Kalau perlu, minta Kepala Cabang Anda.",
  ROLE_FORBIDDEN: PERAN_TIDAK_BERHAK,
  FORBIDDEN_ROLE: PERAN_TIDAK_BERHAK,
  READ_FORBIDDEN: "Peran Anda tidak punya hak untuk melihat data ini. Kalau memang perlu, minta bantuan Kepala Cabang Anda atau Owner.",
  UPLOAD_FORBIDDEN: "Peran Anda tidak bisa menambah berkas di sini. Minta desainer yang ditugaskan atau Kepala Cabang Anda.",
  OWNER_ONLY: HANYA_OWNER,
  HANYA_OWNER: HANYA_OWNER,
  OVERRIDE_ONLY_OWNER: "Melewati batas stok hanya bisa dilakukan Owner. Minta Owner bila memang perlu.",
  OWNER_ONLY_NATIONAL: "Libur nasional dan data semua cabang hanya bisa diatur Owner. Kalau perlu, hubungi Owner.",
  OWNER_APPROVAL_NOT_OWNER: "Persetujuan ini hanya bisa diberikan Owner. Teruskan ke Owner.",
  OWNER_REQUESTER_REQUIRED: "Pengajuan ini hanya bisa dibuat Owner. Kalau perlu, hubungi Owner.",
  APPROVER_ROLE_MISMATCH: "Peran Anda bukan penyetuju untuk pengajuan ini. Teruskan ke Kepala Cabang cabang ini atau Owner.",
  PEMOHON_TIDAK_BOLEH_MENYETUJUI: "Anda yang mengajukan, jadi tidak bisa menyetujui sendiri. Minta Kepala Cabang atau Owner yang menyetujuinya.",
  KOREKSI_PERAN_DITOLAK: "Peran Anda tidak bisa mengajukan koreksi ini. Minta Admin Produksi atau Kepala Cabang Anda.",
  DESIGNER_ONLY: "Tindakan ini hanya untuk desainer. Kalau perlu, minta SPV Desainer mengaturnya.",
  NOT_ASSIGNED: "Tugas ini tidak ditugaskan kepada Anda. Minta SPV Desainer bila tugas perlu dipindah ke Anda.",
  NOT_YOUR_TASK: "Tugas ini sedang dipegang desainer lain. Minta SPV Desainer bila tugas perlu dipindah ke Anda.",
  BUKAN_MILIK_ANDA: "Pengajuan ini milik orang lain, jadi tidak bisa Anda ubah. Tanyakan ke Kepala Cabang Anda.",
  AKUN_TANPA_REGION: "Akun Anda belum punya cabang. Minta Owner mengatur cabang akun Anda.",
  ROLE_TIDAK_BOLEH_MENERBITKAN: "Peran Anda tidak bisa menerbitkan tautan pembayaran. Minta CS atau Kepala Cabang Anda.",
  ROSTER_LOCKED: "Jadwal ini sudah dikunci. Kalau perlu diubah, minta Kepala Cabang Anda.",
  // tidak ditemukan
  NOT_FOUND: "Data tidak ditemukan. Mungkin sudah dihapus atau nomornya salah. Muat ulang halaman, lalu cari lagi dari daftarnya.",
  FA_NOT_FOUND: hilang("FA"),
  WO_NOT_FOUND: hilang("WO"),
  WO_TIDAK_ADA: hilang("WO"),
  DR_NOT_FOUND: hilang("Permintaan desain"),
  CUSTOMER_NOT_FOUND: hilang("Customer"),
  STORE_NOT_FOUND: "Cabang tidak ditemukan. Minta Owner memeriksa daftar cabang.",
  ADJUSTMENT_NOT_FOUND: hilang("Penyesuaian stok"),
  OPNAME_NOT_FOUND: hilang("Stok opname"),
  MATERIAL_NOT_FOUND: hilang("Bahan"),
  REJECT_REMAKE_NOT_FOUND: hilang("Data reject/remake"),
  TASK_NOT_FOUND: hilang("Tugas desain"),
  KARYAWAN_TIDAK_ADA: hilang("Karyawan"),
  PENGAJUAN_TIDAK_ADA: hilang("Pengajuan"),
  KOREKSI_TIDAK_ADA: hilang("Koreksi"),
  SERAH_TERIMA_TIDAK_ADA: hilang("Serah terima"),
  SLIP_TIDAK_ADA: hilang("Slip gaji"),
  PERIODE_TIDAK_ADA: hilang("Periode"),
  TAGIHAN_TIDAK_ADA: hilang("Tagihan"),
  ITERASI_TIDAK_ADA: hilang("Versi desain"),
  RECEIVABLE_NOT_FOUND: hilang("Piutang"),
  REFUND_NOT_FOUND: hilang("Pengembalian dana"),
  COMPLAINT_NOT_FOUND: hilang("Komplain"),
  // keadaan sudah berubah
  ADJUSTMENT_NOT_DRAFT: "Penyesuaian stok ini sudah bukan draf, jadi tidak bisa diubah. Buat penyesuaian baru bila perlu.",
  OPNAME_NOT_IN_PROGRESS: "Stok opname ini belum dimulai atau sudah selesai. Muat ulang halaman untuk melihat keadaannya.",
  KARYAWAN_NONAKTIF: "Karyawan ini sudah tidak aktif. Kalau keliru, minta Kepala Cabang Anda mengaktifkannya.",
  KOREKSI_SUDAH_DIPUTUS: SUDAH_DIPUTUS,
  SUDAH_DIPUTUS: SUDAH_DIPUTUS,
  ALREADY_PROCESSED: "Data ini sudah diproses sebelumnya. Muat ulang halaman untuk melihat hasilnya.",
  RACE_LOST: "Tugas ini baru saja diambil orang lain. Muat ulang halaman lalu pilih tugas lain.",
  PERIODE_SUDAH_ADA: "Periode ini sudah dibuat. Pilih periode itu dari daftar.",
  DUPLICATE_CODE: "Kode ini sudah dipakai. Pakai kode lain.",
  // isian
  PERIODE_TERLALU_JAUH: "Periode yang dipilih terlalu jauh. Pilih periode yang lebih dekat.",
  TANGGAL_TIDAK_SAH: "Tanggal belum benar. Pilih tanggal dari kalender.",
  NO_FIELDS: BELUM_DIUBAH,
  EMPTY_PATCH: BELUM_DIUBAH,
  NO_UPDATABLE_FIELDS: BELUM_DIUBAH,
  ITEMS_REQUIRED: "Isi minimal satu baris barang, lalu kirim lagi.",
  ITEM_QTY_INVALID: "Jumlah barang belum benar. Isi dengan angka lebih dari 0.",
  PAYLOAD_TIDAK_SAH: "Isian belum benar. Periksa lagi lalu kirim ulang.",
  INVALID_FILENAME: "Nama berkas tidak bisa dipakai. Ganti nama berkasnya lalu unggah lagi.",
  EMPTY_FILE: "Berkasnya kosong. Pilih berkas lain lalu unggah lagi.",
  INVALID_ROLE: "Peran tidak dikenali. Pilih peran dari daftar.",
  // sistem
  SIGNED_URL_FAILED: "Berkas belum bisa dibuka saat ini. Coba lagi sebentar lagi; kalau berulang, lapor ke Kepala Cabang.",
};

// Kalimat menurut jenis galat bila backend hanya mengirim kode yang belum ada di peta.
const PESAN_STATUS = {
  400: "Isian belum benar. Periksa lagi lalu coba kirim ulang.",
  401: "Sesi masuk Anda sudah habis. Silakan masuk ulang.",
  403: "Anda tidak punya hak untuk tindakan ini. Kalau memang perlu, minta bantuan Kepala Cabang Anda atau Owner.",
  404: "Data tidak ditemukan. Mungkin sudah dihapus atau nomornya salah. Muat ulang halaman, lalu cari lagi.",
  409: "Tidak bisa diproses karena keadaannya sudah berubah. Muat ulang halaman lalu coba lagi.",
  413: "Berkas terlalu besar. Pilih berkas yang lebih kecil lalu unggah lagi.",
  422: "Isian belum benar. Periksa lagi lalu coba kirim ulang.",
  423: "Data ini sedang dikunci dan belum bisa diubah. Kalau perlu diubah, tanyakan ke Kepala Cabang Anda.",
  429: "Terlalu banyak percobaan. Tunggu sebentar lalu coba lagi.",
};
export const PESAN_SISTEM_BERMASALAH =
  "Sistem sedang bermasalah. Coba lagi sebentar lagi; kalau berulang, lapor ke Kepala Cabang.";
const PESAN_TANPA_JARINGAN = "Tidak tersambung ke sistem. Periksa internet Anda lalu coba lagi.";

function pesanMenurutStatus(err, fallback) {
  const s = err?.response?.status;
  if (s >= 500) return PESAN_SISTEM_BERMASALAH;
  if (PESAN_STATUS[s]) return PESAN_STATUS[s];
  if (err?.request && !err?.response) return PESAN_TANPA_JARINGAN;
  if (err?.code === "ECONNABORTED") return "Sistem terlalu lama menjawab. Coba lagi.";
  return fallback;
}

// Kalimat axios/jaringan berbahasa Inggris tidak pernah tampil ke staf.
const INGGRIS_AXIOS = /^(Request failed with status code|Network Error|timeout of \d+ms exceeded|Request aborted|Not Found$|Forbidden$|Unauthorized$|Internal Server Error$|Method Not Allowed$|Not authenticated$)/i;
// Galat validasi FastAPI/Pydantic (422) datang sebagai DAFTAR {loc, msg, type, ctx}. Dulu jatuh ke pesan umum
// ("Gagal menyimpan bahan.") dan orang tidak tahu kolom mana yang salah (vonis Owner 25 Sep sore butir 4).
const KALIMAT_VALIDASI = {
  greater_than: (c) => `harus lebih dari ${c?.gt}`,
  greater_than_equal: (c) => `minimal ${c?.ge}`,
  less_than: (c) => `harus kurang dari ${c?.lt}`,
  less_than_equal: (c) => `maksimal ${c?.le}`,
  missing: () => "wajib diisi",
  string_too_short: (c) => `minimal ${c?.min_length} karakter`,
  string_too_long: (c) => `maksimal ${c?.max_length} karakter`,
  float_parsing: () => "harus angka",
  int_parsing: () => "harus bilangan bulat",
  string_pattern_mismatch: () => "bentuknya tidak sesuai",
};
// Nama kolom mentah (`qty_counted`) → kata biasa ("qty counted") — K200: nama teknis tidak tampil apa adanya.
export function namaKolom(loc) {
  const bagian = (loc || []).filter((l) => l !== "body" && l !== "query" && typeof l === "string");
  const nama = bagian[bagian.length - 1];
  return nama ? nama.replace(/_/g, " ") : "isian";
}
export function pesanValidasi(daftar) {
  return daftar.map((x) => {
    const f = KALIMAT_VALIDASI[x?.type];
    return `${namaKolom(x?.loc)}: ${f ? f(x?.ctx) : "isinya belum benar"}`;
  }).join("; ");
}
// Kode mentah bergaya KONSTANTA (FA_NOT_FOUND) — tidak pernah jadi kalimat layar.
const KODE_MENTAH = /^[A-Z][A-Z0-9_]+$/;

export function apiErrorMessage(err, fallback = "Terjadi kesalahan.", petaKode = PESAN_KODE_UMUM) {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d) && d.length) return pesanValidasi(d);
  if (d && typeof d === "object") {
    if (typeof d.message === "string" && d.message) return d.message;
    if (typeof d.error === "string" && d.error) {
      return petaKode?.[d.error] || PESAN_KODE_UMUM[d.error] || pesanMenurutStatus(err, fallback);
    }
    return pesanMenurutStatus(err, fallback);
  }
  if (typeof d === "string" && d) {
    if (KODE_MENTAH.test(d) || INGGRIS_AXIOS.test(d)) return PESAN_KODE_UMUM[d] || pesanMenurutStatus(err, fallback);
    return d;
  }
  if (err?.response || err?.request || INGGRIS_AXIOS.test(err?.message || "")) return pesanMenurutStatus(err, fallback);
  return err?.message || fallback;
}

// Special-case: FG negative-stock error → append δ-1 UI guidance sentence.
export function fgNegativeStockMessage(err) {
  const d = err?.response?.data?.detail;
  if (d && d.error === "NEGATIVE_STOCK_BLOCKED") {
    return (
      "Stok barang jadi tidak boleh negatif. Buat adjustment IN terlebih "
      + "dahulu jika stok fisik belum tercatat."
    );
  }
  return apiErrorMessage(err);
}

// Production-in 409 idempotency helper
export function isProductionInDuplicate(err) {
  return (
    err?.response?.status === 409
    && err?.response?.data?.detail?.error === "PRODUCTION_IN_ALREADY_EXISTS"
  );
}
